import {act} from "react-dom/test-utils";

const initialState = {
  breakoutRooms: [],
  peerMap: [],
  nextval: ""
};

const breakoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CREATE_BREAKOUT_ROOM":
      return {...state, breakoutRooms: [...state.breakoutRooms, action.payload.roomId]};

    case "REMOVE_BREAKOUT_ROOM":
      return {...state, breakoutRooms: state.filter(room => room !== action.payload.roomId)};

    case "ADD_USER_TO_PEER_MAP":
      return  {...state, peerMap: [...state.peerMap, ...action.payload.user]};

    case "SET_USERS":
      return {...state, peerMap: action.payload};

    case "NEXT":
      return {...state, nextval: action.payload};

    case "REMOVE_USER_FROM_PEER_MAP":
      return  {...state, peerMap: state.filter(peer => peer.peerId !== action.payload.user.peerId)};

      default:
      return state;
  }
};

export default breakoutReducer;